module.exports = __webpack_public_path__ + "static/municipalities-c68b37c99480711de5d5a1925b97a019.svg";